import o from "./applyInternationalSeparatorStyle.js";
var l = /(\$\d)/;
function m(e, a, t) {
  var r = t.useInternationalFormat,
    i = t.withNationalPrefix,
    n = e.replace(new RegExp(a.pattern()), r ? a.internationalFormat() : i && a.nationalPrefixFormattingRule() ? a.format().replace(l, a.nationalPrefixFormattingRule()) : a.format());
  return r ? o(n) : n;
}
export { l as FIRST_GROUP_PATTERN, m as default };